<template>
  <div>
    <div class="row align-items-end mb-2">
      <div class="col-md-9 col-sm-12">
        <label class="form-label font-weight-bold">Diagnóstico CIE-10</label>
        <v-select-dx v-model="selectedDx" mode="object"></v-select-dx>
      </div>
      <div class="col-md-3 col-sm-12">
        <button type="button" class="btn btn-primary btn-sm btn-block" @click="addDx">
          <i class="fa fa-plus fa-fw"></i> Agregar
        </button>
      </div>
    </div>

    <div v-if="value.length > 0" class="table-responsive">
      <table class="table table-sm table-bordered">
        <thead class="bg-light">
          <tr>
            <th>Código</th>
            <th>Diagnóstico</th>
            <th class="text-center" style="width: 50px;">Acción</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in value" :key="index">
            <td>{{ item.ID_DIAG }}</td>
            <td>{{ (item.diagnostico ? item.diagnostico.DESC_DIAG : item.diagnostico_desc) || item.ID_DIAG }}</td>
            <td class="text-center">
              <button type="button" class="btn btn-danger btn-xs" @click="removeDx(index)">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import VSelectDx from "../../components/common/VSelectDx.vue";

export default {
  name: 'ConditionDetail',
  components:{VSelectDx},
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedDx: null
    };
  },
  methods: {
    addDx() {
      if (!this.selectedDx) return;
      
      // Evitar duplicados
      const exists = this.value.some(item => item.ID_DIAG === this.selectedDx.ID_DIAG);
      if (exists) {
        alert('Este diagnóstico ya ha sido agregado.');
        return;
      }

      const newDetail = {
        tipo_detalle: 'CONDITION',
        ID_DIAG: this.selectedDx.ID_DIAG,
        diagnostico_desc: this.selectedDx.DESC_DIAG
      };

      this.$emit('input', [...this.value, newDetail]);
      this.selectedDx = null;
    },
    removeDx(index) {
      const updated = [...this.value];
      updated.splice(index, 1);
      this.$emit('input', updated);
    }
  }
};
</script>
